import React from "react";
import { SystemOneSymbol } from "./SystemOneSymbol";
import { SystemOneWordMark } from "./SystemOneWordMark";

export const SystemOneLogo = () => {
  return <div className="flex gap-large align-center">
    <SystemOneSymbol />
    <SystemOneWordMark />
  </div>
};